import React from "react";
import { Instagram } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { ViberIcon, WhatsAppIcon } from "./SocialFloat";
import { VIBER_URL, WHATSAPP_URL, INSTAGRAM_URL } from "../data/socials";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/umhdh1t2_Screenshot%202026-06-14%20at%2010.52.34%E2%80%AFPM.png";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-[#0F0F0F] border-t border-[#B08D57]/15">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-20">
        <div className="grid md:grid-cols-12 gap-14">
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="MITROLLARI ENGINEERING SOLUTIONS"
              className="h-20 w-auto object-contain mb-7"
              style={{ mixBlendMode: "screen" }}
            />
            <p className="text-white/55 text-sm leading-[1.75] max-w-xs">{t.footer.tagline}</p>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[#B08D57] mb-6">Menu</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="#home" className="hover:text-[#B08D57] transition-colors">{t.nav.home}</a></li>
              <li><a href="#services" className="hover:text-[#B08D57] transition-colors">{t.nav.services}</a></li>
              <li><a href="#projects" className="hover:text-[#B08D57] transition-colors">{t.nav.projects}</a></li>
              <li><a href="#about" className="hover:text-[#B08D57] transition-colors">{t.nav.about}</a></li>
              <li><a href="#contact" className="hover:text-[#B08D57] transition-colors">{t.nav.contact}</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-[#B08D57] mb-6">{t.nav.contact}</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="tel:+306909418914" className="hover:text-[#B08D57] transition-colors">+30 690 941 8914</a></li>
              <li><a href="mailto:erian.calexambot@gmail.com" className="hover:text-[#B08D57] transition-colors">erian.calexambot@gmail.com</a></li>
              <li>{t.footer.built}</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[#B08D57] mb-6">{t.footer.social}</div>
            <div className="flex items-center gap-3">
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Instagram" className="w-10 h-10 flex items-center justify-center border border-white/15 hover:border-[#B08D57] hover:text-[#B08D57] text-white/70 transition-colors">
                <Instagram className="w-4 h-4" strokeWidth={1.4} />
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" aria-label="WhatsApp" className="w-10 h-10 flex items-center justify-center border border-white/15 hover:border-[#B08D57] hover:text-[#B08D57] text-white/70 transition-colors">
                <WhatsAppIcon className="w-4 h-4" />
              </a>
              <a href={VIBER_URL} data-testid="footer-viber-link" aria-label="Viber" className="w-10 h-10 flex items-center justify-center border border-white/15 hover:border-[#B08D57] hover:text-[#B08D57] text-white/70 transition-colors">
                <ViberIcon className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 overline text-white/35">
          <div>© {year} MITROLLARI ENGINEERING SOLUTIONS — {t.footer.rights}</div>
          <div>{t.footer.built}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
